import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['bar']
  static values = {
    percent: Number,
    animated: Boolean
  }

  connect () {
    // Set initial width to 0 for animation
    this.barTarget.style.width = '0%'

    // Create intersection observer to trigger animation when visible
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !this.animatedValue) {
            this.animateProgress()
            this.animatedValue = true
          }
        })
      },
      {
        threshold: 0.1 // Trigger when 10% visible
      }
    )

    this.observer.observe(this.element)
  }

  disconnect () {
    if (this.observer) {
      this.observer.disconnect()
    }
  }

  animateProgress () {
    // Small delay to ensure the transition is applied
    setTimeout(() => {
      this.barTarget.style.width = `${this.percentValue}%`
    }, 100)
  }

  percentValueChanged () {
    if (this.animatedValue) {
      // If already animated, update immediately
      this.barTarget.style.width = `${this.percentValue}%`
    }
  }
}
